export const GenerateSelectOptions = (offset, max) => {
  const list = []
  for (let i = 0; i < max; i++) {
    const opt = i + offset
    list[i] = {value: opt, label: opt + ''}
  }
  return list
}


// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Prioritize/PlaybookPrioritiesTable/RowGenerator.js